import defaultConfig from './config.json'

const tenantsData = {
  test: {
    VUE_MAIN_TITLE: 'Keep Rising',
    VUE_CSS_MAIN_COLOR: '#216528',
    VUE_MAIN_LOGO:
      'https://static.wixstatic.com/media/957419_ef0773d5b0ff42f28c45849cb54c1fe6~mv2.png/v1/crop/x_11,y_0,w_773,h_203/fill/w_202,h_52,al_c,q_85,usm_0.66_1.00_0.01,enc_auto/F2_5_800x210.png',
    VUE_CSS_BH_BLUE: '#00e01c',
    VUE_CSS_BH_BLUE__1: '#2be93b',
    VUE_CSS_BH_BLUE__2: '#45f44f',
    VUE_CSS_BH_BLUE__3: '#bdffc2',
    VUE_CSS_BH_BLUE__4: '#ebffed',
    VUE_CSS_BH_BLUE__5: '#eef2fe',
    VUE_CSS_BH_BLACK: '#25282B',
    VUE_CSS_BH_GRAY: '#525c53',
    VUE_CSS_BH_GRAY__1: '#525c53',
    VUE_CSS_BH_GRAY__2: '#a0a8a1',
    VUE_CSS_BH_GRAY__3: '#cacfca',
    VUE_CSS_BH_GRAY__4: '#dbe0db',
    VUE_CSS_BH_GRAY__5: '#e8e8e8',
    VUE_CSS_BH_GRAY__6: '#f6f8fb',
    VUE_CSS_BH_NEW_GRAY: '#f6faf7',
    VUE_CSS_BH_WHITE: '#ffffff',
    VUE_CSS_BH_YELLOW: '#9a32fa',
    VUE_CSS_BH_YELLOW__DARK: '#870aef',
    VUE_CSS_BH_YELLOW__LIGHT: '#cc98fc',
    VUE_CSS_BH_GREEN: '#98d016',
    VUE_CSS_BH_GREEN__DARK: '#84b503',
    VUE_CSS_BH_GREEN__LIGHT: '#bbee34',
    VUE_CSS_BH_RED: '#60ffed',
    VUE_CSS_BH_RED__DARK: '#48e7d2',
    VUE_CSS_BH_RED__LIGHT: '#77fff0',
  },
  olympianbydesign: {
    VUE_MAIN_TITLE: 'Olympian By Design',
    VUE_CSS_MAIN_COLOR: '#3a3c3e',
    VUE_MAIN_LOGO: '@/assets/bhi_logo.png',
    VUE_LOGO_ALT: 'Olympian By Design',
    VUE_CSS_BH_BLUE: '#989484',
    VUE_CSS_BH_BLUE__1: '#b39964',
    VUE_CSS_BH_BLUE__2: '#c1b8a2',
    VUE_CSS_BH_BLUE__3: '#d2ccbc',
    VUE_CSS_BH_BLUE__4: '#eeeadf',
    VUE_CSS_BH_BLACK: '#25282b',
    VUE_CSS_BH_GRAY: '#52575c',
    VUE_CSS_BH_GRAY__1: '#52575c',
    VUE_CSS_BH_GRAY__2: '#a0a4a8',
    VUE_CSS_BH_GRAY__3: '#cacccf',
    VUE_CSS_BH_GRAY__4: '#dbdde0',
    VUE_CSS_BH_GRAY__5: '#e8e8e8',
    VUE_CSS_BH_GRAY__6: '#f6f8fb',
    VUE_CSS_BH_NEW_GRAY: '#f6f6fa',
    VUE_CSS_BH_WHITE: '#ffffff',
    VUE_CSS_BH_YELLOW: '#fac032',
    VUE_CSS_BH_YELLOW__DARK: '#efad0a',
    VUE_CSS_BH_YELLOW__LIGHT: '#fcdf98',
    VUE_CSS_BH_GREEN: '#16d090',
    VUE_CSS_BH_GREEN__DARK: '#03b575',
    VUE_CSS_BH_GREEN__LIGHT: '#34eeae',
    VUE_CSS_BH_RED: '#ff6760',
    VUE_CSS_BH_RED__DARK: '#e74f48',
    VUE_CSS_BH_RED__LIGHT: '#ff7e77',
  },
  brainhealthinitiative: {
    VUE_MAIN_TITLE: 'Brain Health Initiative',
    VUE_CSS_MAIN_COLOR: '#0F456E',
    VUE_MAIN_LOGO: '@/assets/bhi_logo.png',
    VUE_LOGO_ALT: 'Brain Health Initiative',
    VUE_CSS_BH_BLUE: '#59697F',
    VUE_CSS_BH_BLUE__1: '#2bb2e9',
    VUE_CSS_BH_BLUE__2: '#45c2f4',
    VUE_CSS_BH_BLUE__3: '#bdd0ff',
    VUE_CSS_BH_BLUE__4: '#ceeef5',
    VUE_CSS_BH_BLACK: '#25282b',
    VUE_CSS_BH_GRAY: '#52575c',
    VUE_CSS_BH_GRAY__1: '#52575c',
    VUE_CSS_BH_GRAY__2: '#a0a4a8',
    VUE_CSS_BH_GRAY__3: '#cacccf',
    VUE_CSS_BH_GRAY__4: '#dbdde0',
    VUE_CSS_BH_GRAY__5: '#e8e8e8',
    VUE_CSS_BH_GRAY__6: '#f6f8fb',
    VUE_CSS_BH_NEW_GRAY: '#f6f6fa',
    VUE_CSS_BH_WHITE: '#ffffff',
    VUE_CSS_BH_YELLOW: '#fac032',
    VUE_CSS_BH_YELLOW__DARK: '#efad0a',
    VUE_CSS_BH_YELLOW__LIGHT: '#fcdf98',
    VUE_CSS_BH_GREEN: '#16d090',
    VUE_CSS_BH_GREEN__DARK: '#03b575',
    VUE_CSS_BH_GREEN__LIGHT: '#34eeae',
    VUE_CSS_BH_RED: '#ff6760',
    VUE_CSS_BH_RED__DARK: '#e74f48',
    VUE_CSS_BH_RED__LIGHT: '#ff7e77',
  },
}

const tenantId = defaultConfig.VUE_TENANT_ID
let extendedConfig = {
  ...defaultConfig,
}
if (tenantId && tenantsData[tenantId]) {
  extendedConfig = { ...extendedConfig, ...tenantsData[tenantId] }
}

export default extendedConfig
